export default __webpack_public_path__ + "static/media/code2.b19806c9.png";